import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getDataSource, DATASOURCES } from 'state/services/utils';
import {
  getMyTeam,
  getMyPermissions,
  getMyProfile,
} from 'auth/state/userDataUtils';

export const UserProfileContext = React.createContext({});

function hasMeData(me) {
  return me && me.data;
}

export const initialState = {
  profile: null,
  team: null,
  permissions: null,
  authorizationType: null,
};

class UserProfileProvider extends Component {
  constructor(props) {
    super(props);

    this.state = {
      profile: props.profile || null,
      team: props.team || null,
      permissions: props.permissions || null,
      authorizationType: props.authorizationType || null,
      isPhysician: () => {
        const { permissions } = this.state;
        return permissions && permissions.isPhysician;
      },
      hasUserData: () => {
        return this.state.profile !== null;
      },
    };

    // TODO: Have this be the only component that tries to fetch ME data.
    // Navigation sidebar is doing this currently.
  }

  componentDidUpdate(prevProps) {
    // should clear user context upon logged out/session expired.
    if (this.props.profile && this.props.profile !== prevProps.profile) {
      this.updateUserContext();
    }
  }

  updateUserContext() {
    const { profile, team, permissions, authorizationType } = this.props;
    this.setState({
      profile,
      permissions,
      team,
      authorizationType,
    });
  }

  render() {
    const { children } = this.props;
    return (
      <UserProfileContext.Provider value={this.state}>
        {children}
      </UserProfileContext.Provider>
    );
  }
}
const mapStateToProps = state => {
  // console.log(state);
  const me = getDataSource(state, DATASOURCES.ME);
  const { auth } = state;
  const props = {
    me,
    auth,
    authorizationType: auth.authorizationType,
  };

  if (hasMeData(me)) {
    return {
      ...props,
      profile: getMyProfile(me),
      permissions: getMyPermissions(me),
      team: getMyTeam(me),
    };
  }

  return props;
};

export default connect(mapStateToProps)(UserProfileProvider);



// WEBPACK FOOTER //
// ./src/auth/contexts/UserProfileContext.jsx